
import {
    computed,
    defineComponent,
    onMounted,
    reactive,
    Ref,
    ref,
    toRaw,
    watch,
} from "vue";
import { UserOutlined, PlaySquareOutlined } from "@ant-design/icons-vue";
import NavBottom from "@/components/NavBottom.vue";
import { uploadflie } from "@/utils/vod";
import store from "@/store";
import smile from "@/static/images/smile.png";
import smilet from "@/static/images/smilet.png";
import imghead from "@/components/imghead.vue"
import {
    changetel,
    checksmscode,
    editpassword,
    editsystemsetting,
    getarchives,
    getcurrencys,
    getlanguages,
    getquhaolist,
    getzonelist,
    interests,
    putmember,
    sendsms,
    setheadimg,
    setusername,
} from "@/api/index";
import { message } from "ant-design-vue";
import { useI18n } from "@/utils/i18n";
import { provenimg, provenvideo, saveValue } from '@/utils/common';

export default defineComponent({
    name: "Archives",
    components: {
        UserOutlined,
        PlaySquareOutlined,
        NavBottom,
        imghead
    },
    setup() {
        let issum = true;
        const lan: any = useI18n();
        const touxiang = ref(false);
        interface SpeakItem {
            lang: string;
            proficiency: number;
        }
        const otherSpeak: Array<SpeakItem> = [
            {
                lang: "请选择",
                proficiency: 0,
            },
        ];
        const userinfo = computed(() => {
            return store.state.userinfo;
        });
        const huobi = ref(false);
        // 表单数据
        const currencyindex = ref<string>(userinfo.value.currency);
        const formData = ref(toRaw(userinfo.value));
        watch(userinfo, () => {
            formData.value = toRaw(userinfo.value);
            // console.log(lan.$s(), formData.value.languageValue)
            
            console.log(userinfo.value.currencyValue, "listsssss");
            currencyindex.value = userinfo.value.currency;
            console.log(currencyindex.value, "listsssss");
        });
        const modalNode = () =>
            document.getElementsByClassName("modal-container")[0];

        const chiveslist = ref<any>([[], []]);
        const languages = ref<unknown>([]);
        const quhaolist = ref<any>([]);
        const mrqh = computed(() => store.state.qh)
        
        const myquhao = ref<string>(mrqh.value.code);

        const mynewtel = ref<string>("");

        const isSecondStep: Ref<boolean> = ref(false);
        const currencylist = ref<any>([
            {
                alias: "CNY",
                code: "104110041000",
                createdAt: "2020-08-19 11:54:59",
                deletedAt: null,
                dictionaryid: 241,
                name: "人民币￥",
                position: 1,
                publish: 1,
                updatedAt: "2020-08-19 11:54:59",
                value: "1",
            },
        ]);
        const zonelist = ref<any>([
            {
                city: "中途岛",
                gmt: "GMT-11:00",
                id: "Pacific/Midway",
                zoneid: 1,
            },
        ]);
        const interestslist = ref<any>([
            {
                "dictionaryid": 202,
                "name": "中文",
                "alias": "",
                "code": "104110001000",
                "position": 1,
                "publish": 1,
                "value": "1",
                "deleted_at": null,
                "created_at": "2020-08-13 18:17:18",
                "updated_at": "2020-08-13 18:17:18"
            }
        ])
        onMounted(async () => {
            chiveslist.value = await getarchives();
            languages.value = await getlanguages();
            quhaolist.value = await getquhaolist();
            myquhao.value = quhaolist.value[0].code;
            currencylist.value = await getcurrencys();
            zonelist.value = await getzonelist();
            interestslist.value = await interests();
            // currencyindex.value=userinfo.value.currencyValue
            console.log(userinfo.value);
        });

        /**
         * 修改用户名
         * @return { void }
         */
        const showname = ref(true);
        function updateUserName(): void {
            console.log("修改");
            showname.value = false;
        }
        /**
         * 添加我还会说语言
         * @return { void }
         */
        function addSpeakLang(): void {
            formData.value.willsay.push({
                name: "请选择",
                level: 0,
            });
            formData.value.willsayValue.push({
                name: "",
                level: 0,
            });
        }
        // 验证码
        const verificationCode: Ref<string> = ref(""),
            updatePhoneVisible: Ref<boolean> = ref(false);
        /**
         * 关闭手机对话框 清空数据
         */
        function hidePhoneModal(): void {
            verificationCode.value = "";
            isSecondStep.value = false;
            console.log("close");
        }
        /**
         * 显示修改手机号对话框
         */
        function togglePhoneModal(value: boolean): void {
            updatePhoneVisible.value = value;
            if (!value) {
                hidePhoneModal();
            }
        }
        // 获取验证码间隔
        const remainTime: Ref<number> = ref(0);
        /**
         * 计算验证码倒计时
         */
        function computedVerificationCode(): void {
            remainTime.value = 60;
            const timer = setInterval(() => {
                if (remainTime.value > 0) {
                    remainTime.value--;
                } else {
                    clearInterval(timer);
                }
            }, 1000);
        }
        /**
         * 发送验证码
         */
        function sendVerificationCode(code: string ,tel: string): void {
            if (remainTime.value === 0) {
                computedVerificationCode();
                console.log(tel, "send");
                sendsms(code, tel);
            }
        }
        // 绑定手机号是否是第二步
        interface BindPhoneItem {
            number: string | number;
            code: string | number;
        }
        const bindPhone: BindPhoneItem = reactive({
            number: "",
            code: "",
        });
        /**
         * 绑定手机号下一步
         */
        async function nextPhoneStep(): Promise<void> {
            remainTime.value = 0;
            if (!isSecondStep.value) {
                console.log(formData.value.code);
                if (verificationCode.value == "") {
                    return;
                }
                const res = await checksmscode(
                    formData.value.code + formData.value.mobile,
                    verificationCode.value
                );
                console.log(res, "0.0");
                if (res) {
                    isSecondStep.value = true;
                }
                // isSecondStep.value = true;
            }

            // isSecondStep.value = true;
        }
        /**
         * 修改手机号
         * @return { void }
         */
        async function updatePhoneNumber(): Promise<void> {
            console.log("修改手机号");
            console.log(mynewtel.value, myquhao.value, bindPhone.code);
            const res = await checksmscode(
                myquhao.value + mynewtel.value,
                bindPhone.code.toString()
            );
            console.log(res, "xiugai");
            if (res) {
                const res1 = await changetel(myquhao.value, mynewtel.value);
                if (res1) {
                    store.dispatch("setUserInfo");
                    updatePhoneVisible.value = false;
                }
            }
        }
        function getquhao(e?: any) {
            console.log(e);
            myquhao.value = e.toString();
            myquhao.value = myquhao.value.split("+")[1];
        }
        // 是否显示修改密码框
        const updatePasswordVisible: Ref<boolean> = ref(false);
        interface PassWord {
            original?: string;
            password?: string;
            topassword?: string;
            memberid?: number;
        }
        const passwordForm: PassWord = reactive({
            original: "",
            password: "",
            topassword: "",
            memberid:0

        });
        /**
         * 密码对话框清空数据
         */
        function hidePasswordModal(): void {
            passwordForm.original = "";
            passwordForm.password = "";
            passwordForm.topassword = "";
        }
        /**
         * 显示修改密码对话框
         */
        function togglePasswordModal(value: boolean): void {
            updatePasswordVisible.value = value;
            if (!value) {
                hidePasswordModal();
            }
        }
        /**
         * 修改密码
         * @return { void }
         */
        async function updateUserPassword(): Promise<void> {
            passwordForm.memberid = userinfo.value.memberid
            console.log(toRaw(passwordForm));
            if (
                toRaw(passwordForm).password === toRaw(passwordForm).topassword 
            ) {
                if (toRaw(passwordForm).original != "") {
                    // console.log(toRaw(passwordForm).password);
                    const res = await editpassword(toRaw(passwordForm));
                    togglePasswordModal(res);
                } else {
                    message.error(lan.$t('yuanmimaweikong'));
                }
            } else {
                message.error(lan.$t('mimabuyizhi'));
            }
        }
        /**
         * 提交表单
         * @return { void }
         */
        async function submitInfo(): Promise<void> {
            //  for(let i in toRaw(formData.value).willsay){
            //     console.log(toRaw(formData.value).willsay[i])
            // }
            if(!issum){
                message.error(lan.$t("shangchuanwancheng"))
                return; 
            }
            const uesrinfo = toRaw(formData.value);
            // for (let m = 0; m < toRaw(chiveslist.value).length; m++) {
            //     for (const i in uesrinfo.willsayValue) {
            //         // console.log(toRaw(formData.value).willsayValue[i])

            //         if (typeof uesrinfo.willsay[i].name == "string") {
            //             // console.log(toRaw(chiveslist.value))
            //             if (
            //                 uesrinfo.willsay[i].name ==
            //                 toRaw(chiveslist.value)[m].name
            //             ) {
            //                 uesrinfo.willsayValue[i].name = toRaw(
            //                     chiveslist.value
            //                 )[m].languageid;
            //             }
            //         } else {
            //             uesrinfo.willsayValue[i].name =
            //                 uesrinfo.willsay[i].name;
            //         }

            //         uesrinfo.willsayValue[i].level = uesrinfo.willsay[i].level;
            //     }
            // }

            for(const i in uesrinfo.willsay){
                if(uesrinfo.willsay[i].name == '请选择'){
                    console.log(111)
                    break;
                }
                for(const j in chiveslist.value[1]){
                    if(uesrinfo.willsay[i].name == chiveslist.value[1][j].name){
                        uesrinfo.willsay[i].name = chiveslist.value[1][j].languageid
                    }
                    console.log(uesrinfo.willsay[i].name, chiveslist.value[1][j].name)
                }
            }
            const arr: any = {};
            for(const i in uesrinfo.willsay){
                // const a: any = {};
                if(uesrinfo.willsay[i].name == '请选择'){
                    console.log(111)
                    break;
                }
                arr[uesrinfo.willsay[i].name] = uesrinfo.willsay[i].level
                // arr.push(a);
                // arr.push({uesrinfo.willsay[i].name})
            }
            uesrinfo.willsay = arr;
            console.log(uesrinfo);

            // console.log(toRaw(formData.value));
            // if (uesrinfo.currency == "") {
            //     if (uesrinfo.currencyValue != "") {
            //         for (let i = 0; i < currencylist.value.length; i++) {
            //             if (
            //                 uesrinfo.currencyValue ==
            //                 currencylist.value[i].name
            //             ) {
            //                 uesrinfo.currency = currencylist.value[i].value;
            //             }
            //         }
            //     }
            // }
            // eslint-disable-next-line
            const reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
            console.log(userinfo.value.email);
            // console.log();
            // for (let i = 0; i < currencylist.value.length; i++) {
            //     if (
            //         uesrinfo.currencyValue ==
            //         currencylist.value[i].name
            //     ) {
            //         uesrinfo.currency = currencylist.value[i].value;
            //     }
            // }
            for(const i in chiveslist.value[0]){
                if(chiveslist.value[0][i].name == uesrinfo.country){
                    uesrinfo.countryValue = chiveslist.value[0][i].id
                }
            }
            for(const i in zonelist.value){
                if((zonelist.value[i].city + zonelist.value[i].gmt) == uesrinfo.zoneStr){
                    uesrinfo.zoneid = zonelist.value[i].zoneid
                }
                // console.log(zonelist.value[i].city + zonelist.value[i].gmt, uesrinfo.zoneStr)
            }
            if (reg.test(userinfo.value.email)) {
                await putmember(uesrinfo);
                if(lan.$s() != uesrinfo.languageValue){
                    saveValue("Lanvuage", uesrinfo.languageValue)
                    location.reload();
                }
            } else {
                message.error(lan.$t('youxiangcuowu'));
            }
        }

        // uploadflie()3.

        function setlevel(index: number, level: number) {
            store.state.userinfo.willsay[index].level = level;
        }

        /**
         * 上传视频
         */
        interface AntUpload {
            action: string;
            data: unknown;
            file: File;
        }
        const uploadprogress: Ref<number> = ref(0);
        async function uploads(file: AntUpload) {
            console.log(1111)
            uploadprogress.value = 1;
            issum = false;
            const res = await uploadflie(file.file, (info: any) => {
                console.log(info);
                let jindu: number = info.percent.toFixed(2) * 100;
                jindu = parseInt(jindu + "");
                uploadprogress.value =  jindu > 0 ? jindu : 1;
            });
            userinfo.value.video = res.video.url;
            formData.value.video = res.video.url;
            userinfo.value.videoid = res.fileId;
            issum = true;
        }

        if (formData.value.video != "") {
            uploadprogress.value = 100;
        }
        watch(formData, () => {
            if (formData.value.video != "" && uploadprogress.value == 0) {
                uploadprogress.value = 100;
                console.log("赋值100")
            }
            console.log(formData.value.country)
        });
       
        function choosewillsay(e?: any) {
            console.log(formData.value.willsayValue);

            console.log(e);
        }
        
        function isdisabled(name: string){
            for(const i in formData.value.willsay){
                if(formData.value.willsay[i].name == name){
                    return true;
                }else{
                    return false;
                }
            }
        }

        function currencychange(e?: any) {
            console.log(e);
            huobi.value = true;
            userinfo.value.currencyValue = e;
            // editsystemsetting({currency:e})
        }
        const imgfire = ref<any>()
        async function uploadspic(file: AntUpload) {
            // const res = await uploadflie(file.file, (info: any) => {
            //     console.log(info);
            //     // uploadpicprogress.value = info.percent.toFixed(2) * 100;
            // });
            // console.log(res);

            // //  picinfo.fileId=res.fileId
            // //  picinfo.url=res.video.url
            // formData.value.img = res.video.url;
            // setheadimg(res.video.url);
            console.log(file.file)
            imgfire.value = file.file;
            touxiang.value = true;

        }
        function imgupload(res: any){
            formData.value.img = res.video.url;
            setheadimg(res.video.url);
            touxiang.value = false;
        }

        // function beforeVideoUpload(file: any){
        //     console.log(file)
        //     const type = provenvideo(file.name);
        //     // if(!type){
        //     //     message.error("文件类型错误,请重新选择")
        //     // }
        //     return type;
        // }
        function video(file: any){
            return provenvideo(file)
        }
         function imgs(file: any){
            return provenimg(file)
        }
        function setname(){
            setusername(formData.value.name).then(()=>{
                showname.value = true;
            })
        }

        // function selguojia(e: any){
        //     userinfo.value.countryValue = e;
        //     console.log(e)
        // }

        return {
            modalNode,
            formData,
            updateUserName,
            addSpeakLang,
            verificationCode,
            updatePhoneVisible,
            hidePhoneModal,
            sendVerificationCode,
            remainTime,
            isSecondStep,
            nextPhoneStep,
            bindPhone,
            updatePhoneNumber,
            togglePhoneModal,
            updatePasswordVisible,
            togglePasswordModal,
            hidePasswordModal,
            passwordForm,
            updateUserPassword,
            submitInfo,
            userinfo: formData,
            uploads,
            smile,
            smilet,
            setlevel,
            chiveslist,
            languages,
            uploadprogress,
            choosewillsay,
            mynewtel,
            quhaolist,
            getquhao,
            myquhao,
            currencylist,
            zonelist,
            currencychange,
            currencyindex,
            showname,
            uploadspic,
            lan,
            interestslist,
            isdisabled,
            setname,
            video,
            imgs,
            mrqh,
            huobi,
            touxiang,
            imgfire,
            imgupload
        };
    },
});
